import Vue from 'vue';
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
export default Vue.extend({
  name: 'MaterialBoxTabTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    id: {
      type: String,
      default: ''
    }
  },
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  render() {
    var _this$designer$$scope, _this$designer$$scope2;
    const h = arguments[0];
    const childrenFromDesigner = (_this$designer$$scope = this.designer.$scopedSlots) === null || _this$designer$$scope === void 0 || (_this$designer$$scope2 = _this$designer$$scope.materialBoxTabTitle) === null || _this$designer$$scope2 === void 0 ? void 0 : _this$designer$$scope2.call(_this$designer$$scope, {
      title: this.title,
      id: this.id
    });
    return h("div", {
      "class": "uc-tabs-item-text"
    }, [childrenFromDesigner || this.title]);
  }
});
//# sourceMappingURL=material-box-tab-title.js.map
